<template>
  <InfoDialog
    :show-dialog="show"
    :config="ssoPreferredDialog"
    :show-action-flag="false"
    info-text="app.ssoPreferredInfo"
    @update:show-dialog="show = $event"
    @execute-action="closeDialog"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ssoPreferredDialog } from '@/models/generalDialogConfig';
import { setLoginWithPasswordInLocalStorage } from '@/util/authentication';

export default defineComponent({
  name: 'SSOPreferredDialog',
  props: {
    showDialog: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:showDialog'],
  data() {
    return {
      ssoPreferredDialog
    };
  },
  computed: {
    show: {
      get() {
        return this.showDialog;
      },
      set(value) {
        this.$emit('update:showDialog', value);
      }
    }
  },
  methods: {
    closeDialog(): void {
      this.show = false;
      setLoginWithPasswordInLocalStorage(false);
    }
  }
});
</script>
